exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tituloHomologacao {\n  color: yellow;\n  font-size: 1.2em;\n}", ""]);

// exports
